export default {

    methods: {
        clearCart() {
            localStorage.removeItem('shopCart');
  
        },
        removeItemCart(product) {
            let card = JSON.parse(localStorage.getItem('shopCart')) || [];

            let indexOfExistingProduct = card.findIndex(
                (el) => el.id === product.id
            );
            if(product.qty > 1 ) {
                product.qty -= 1;
                card[indexOfExistingProduct].qty -= 1;
            }

            if(product.qty === 0 ){
                card.splice(indexOfExistingProduct, 1);

            }
            localStorage.setItem('shopCart',JSON.stringify(card));
        },
        getCart() {
            let card = JSON.parse(localStorage.getItem('shopCart'));
            return card;
        },

        deleteLigne(product){
            let card = JSON.parse(localStorage.getItem('shopCart')) || [];
            const filteredCard = card.filter((item)=>{
                return item.id !== product.id
            })
            localStorage.setItem('shopCart',JSON.stringify(filteredCard));

        },
        getCartCount(card) {
            let count = card.reduce((total, item) => total + item.qty, 0);
            return count;
        }


    }

}



